import { render, staticRenderFns } from "./VotingRightsUpload.vue?vue&type=template&id=4a6c45f6"
import script from "./VotingRightsUpload.vue?vue&type=script&lang=js"
export * from "./VotingRightsUpload.vue?vue&type=script&lang=js"
import style0 from "./VotingRightsUpload.vue?vue&type=style&index=0&id=4a6c45f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports